export class CardSettings {
    constructor(
        public reward: number,
        public cost: number,
        public penalty: number,
        public attempts: number,
        public characters: Array<number>,
        public kairos_bonus: number
    ) {}
}
